import { UserState } from "@/models/UserState.d.ts";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";


export const getDefaultState = (): UserState => {
    return {
        user: undefined,
        accessToken: "",
        errorMsg: "",
        errorCode: 0,
        terms: "",
        isPlayingVideo: false,
    }
};

const state: UserState = getDefaultState();

export default {
    state,
    getters,
    mutations,
    actions
};
